<div class="api-collection">
  <div class="-filter-results">
    <section class="-results">
      @for (product of apis; track trackByProductIdentity($index, product)) {
      <card-category-product
        class="card-category"
        totype="title"
        [title]="product.productTitle"
        [to]="product.productTo"
        [version]="product.beta ? 'BETA' : null">
        <p>{{ product.productDescription }}</p>
        <span class="-product-pill">
          @for (region of splitRegions(product.region); track region) {
          <pill-country [icon]="countryIconName(region)">
            {{ region }}
          </pill-country>
          } @for (tag of product.tags; track tag) {
          <pill-country>
            {{ tag }}
          </pill-country>
          }
        </span>
      </card-category-product>
      }
    </section>
  </div>
</div>
